<template>
	<div class="lbt_box">
		
		<div class="lbt_one" v-if="num==1">
			<div class="lb_1">
				<img class="lb_1img" src="../static/home/lb_a1.png" alt="" />
			</div>
			
			<img class="lb_a2" src="../static/home/lb_a2.png" alt="" />
			
			<img class="lb_a3" src="../static/home/lb_a3.png" alt="" />
			
			<div>
				<img class="juanzhou" src="../static/home/juanzhou.png" alt="" />
			</div>
			
		</div>
		
		<div class="lbt_one" v-if="num==2">
			<div class="lb_1">
				<img class="lb_1img" src="../static/home/lb_b1.png" alt="" />
			</div>
			
			<img class="lb_b2" src="../static/home/lb_b2.png" alt="" />
			
			<img class="lb_b3" src="../static/home/lb_b3.png" alt="" />
			
			<img class="juanzhou" src="../static/home/juanzhou.png" alt="" />
		</div>
		
		<div class="lbt_one" v-if="num==3">
			<div class="lb_1">
				<img class="lb_1img" src="../static/home/lb_c1.png" alt="" />
			</div>
			
			<img class="lb_c2" src="../static/home/lb_c2.png" alt="" />
			
			<img class="lb_c3" src="../static/home/lb_c3.png" alt="" />
			
			<img class="juanzhou" src="../static/home/juanzhou.png" alt="" />
		</div>
		
		<div class="lbt_one" v-if="num==4">
			<div class="lb_1">
				<img class="lb_1img" src="../static/home/lb_d1.png" alt="" />
			</div>
			
			<img class="lb_d2" src="../static/home/lb_d2.png" alt="" />
			
			<img class="lb_d3" src="../static/home/lb_d3.png" alt="" />
			
			<img class="juanzhou" src="../static/home/juanzhou.png" alt="" />
		</div>
		
		<div class="lbt_one" v-if="num==5">
			<div class="lb_1">
				<img class="lb_1img" src="../static/home/lb_e1.png" alt="" />
			</div>
			
			<img class="lb_e2" src="../static/home/lb_e2.png" alt="" />
			
			<img class="lb_e3" src="../static/home/lb_e3.png" alt="" />
			
			<img class="juanzhou" src="../static/home/juanzhou.png" alt="" />
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tirm : null,	//定时器
				num : 1,		//第几个
			}
		},
		created() {
			this.Rotation();
		},
		methods:{
			Rotation(){
				var that = this
				this.tirm = setInterval(function(){
					if(that.num<5){
						that.num++ 
					}else{
						that.num=1
					}
				},14000)
			},
		},
		
		beforeDestroy(){	//退出页面时间
			clearInterval(this.tirm)
			this.tirm = null;
		}
	}
</script>

<style scoped lang="less">
	.lbt_box{
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	// 
	.lbt_one{
		width: 1918px;
		height: 730px;
		position: absolute;
		top: 51%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
	.lb_1{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 1803px;
		height: 675px;
		opacity: 0;
		animation:  lb1_ain 12s linear;
		animation-fill-mode: forwards;
		overflow: hidden;
	}
		@keyframes lb1_ain {
			0%{
				width: 0%;
				opacity: 0;
			}
			32%{
				width: 100%;
				opacity: 1;
			}
			
			80%{
				width: 100%;
				opacity: 1;
			}
			100%{
				width: 0%;
				opacity: 0;
			}
		}
	.lb_1img{
		width: 1918px;
		height: 675px;
	}
	.juanzhou{
		width: 362px;
		height: 533px;
		position: absolute;
		z-index: 5;
		top: 23px;
		left: 50px;
		opacity: 0;
		transform:rotate(60deg);
		animation: lb_ain 12s linear ;
		animation-fill-mode: forwards;
	}
	@keyframes lb_ain {
		0%{
			top: 2.12vh;
			left: 2.6vw;
			opacity: 0;
			transform:rotate(60deg);
		}
		9%{
			top: 4.16vh;
			left: 17.7vw;
			opacity: 1;
			transform:rotate(33deg);
		}
		19%{
			top: 19.72vh;
			left: 52vw;
			transform:rotate(30deg);
		}
		
		29%{
			top: 11.39vh;
			left: 82vw;
			transform:rotate(30deg);
		}
		30%{
			top: 15vh;
			left: 83vw;
			transform:rotate(0deg);
		}
		80%{
			top: 15vh;
			left: 83vw;
			transform:rotate(0deg);
		}
		82%{
			top: 11.39vh;
			left: 82vw;
			transform:rotate(30deg);
		}
		
		87%{
			top: 19.72vh;
			left: 52vw;
			transform:rotate(30deg);
		}
		
		98%{
			top: 2.12vh;
			left: 2.6vw;
			opacity: 1;
			transform:rotate(60deg);
		}
		
		100%{
			top: 2.12vh;
			left: 2.6vw;
			opacity: 0;
			transform:rotate(60deg);
		}
	}
	
	
	.lb_a2{
		width: 637px;
		height: 110px;
		position: absolute;
		top: 0;
		left: 935px;
		opacity: 0;
		animation: lb2_ain 12s !important;
		animation-fill-mode: forwards;
	}
		@keyframes lb2_ain{
			0%{
				transform: scale(1.2);
				opacity: 0;
			}
			30%{
				transform: scale(1.2);
				opacity: 0;
			}
			
			50%{
				transform: scale(1);
				opacity: 1;
			}
			
			80%{
				transform: scale(1);
				opacity: 1;
			}
			100%{
				transform: scale(1.2);
				opacity: 0;
			}
		}
	.lb_a3{
		width: 366px;
		height: 45px;
		position: absolute;
		top: 115px;
		left: 1074px;
		
		opacity: 0;
		animation: lb3_ain 12s;
		animation-fill-mode: forwards;
	}
		@keyframes lb3_ain{
			0%{
				transform: translateX(100px);
				opacity: 0;
			}
			30%{
				transform: translateX(100px);
				opacity: 0;
			}
			
			50%{
				transform: translateX(0px);
				opacity: 1;
			}
			
			80%{
				transform: translateX(0px);
				opacity: 1;
			}
			100%{
				transform: translateX(100px);
				opacity: 0;
			}
		}
	
	
	// 
	.lb_b2{
		width: 637px;
		height: 110px;
		position: absolute;
		top: 0;
		left: 935px;
		opacity: 0;
		animation: lb2_ain 12s;
		animation-fill-mode: forwards;
	}
	.lb_b3{
		width: 264px;
		height: 48px;
		position: absolute;
		top: 115px;
		left: 1134px;
		
		opacity: 0;
		animation: lb3_ain 12s;
		
		animation-fill-mode: forwards;
	}
	
	// 
	.lb_c2{
		width: 560px;
		height: 137px;
		position: absolute;
		top: 0;
		left: 965px;
		
		opacity: 0;
		animation: lb2_ain 12s;
		
		animation-fill-mode: forwards;
	}
	.lb_c3{
		width: 235px;
		height: 46px;
		position: absolute;
		top: 140px;
		left: 1126px;
		
		opacity: 0;
		animation: lb3_ain 12s;
		
		animation-fill-mode: forwards;
	}
	
	// 
	.lb_d2{
		width: 560px;
		height: 137px;
		position: absolute;
		top: 0;
		left: 965px;
		
		opacity: 0;
		animation: lb2_ain 12s;
		
		animation-fill-mode: forwards;
	}
	.lb_d3{
		width: 452px;
		height: 48px;
		position: absolute;
		top: 140px;
		left: 1042px;
		
		opacity: 0;
		animation: lb3_ain 12s;
		
		animation-fill-mode: forwards;
	}
	
	// 
	.lb_e2{
		width: 560px;
		height: 137px;
		position: absolute;
		top: 0;
		left: 965px;
		
		opacity: 0;
		animation: lb2_ain 12s;
		
		animation-fill-mode: forwards;
	}
	.lb_e3{
		width: 452px;
		height: 48px;
		position: absolute;
		top: 140px;
		left: 1037px;
		
		opacity: 0;
		animation: lb3_ain 12s;
		
		animation-fill-mode: forwards;
	}
	
	
</style>